import { Chart } from 'chart.js';

Chart.defaults.font.weight = '500';
Chart.defaults.font.size = 12;
Chart.defaults.font.family = "'Inter', sans-serif";
Chart.defaults.color = '#898792';
